import { gql } from 'graphql-request'

export const QueryUspList = gql`
  fragment FragmentBlockUspList on BlockUspListModelRecord {
    __typename
    id
    preface
    title
    description {
      value
    }
    simpleContentBlocks {
      ...FragmentSimpleBlock
    }
    primaryAction {
      ...FragmentNavigationItem
    }
    backgroundColor
  }
`

export const BlockUspList = {
  __typename: 'BlockUspList',
  fragmentName: 'FragmentBlockUspList',
  fragmentQuery: QueryUspList,
  fragments: ['FragmentNavigationItem', 'FragmentSimpleBlock', 'FragmentFormattedTextBlock']
}
